import { CountCellProps } from '../../types';
import EntityRetryThreeDot from 'components/EntityRetryThreeDot';
import { ComponentProps } from 'react';

const OptionCell = ({ _customRowProps, dataType }: CountCellProps) => {
  const { openEntityRetryMenu, teamId, targetServiceId, isTwoWaySync } = _customRowProps;

  const onThreeDotClick: ComponentProps<typeof EntityRetryThreeDot>['onClick'] = (e) => {
    openEntityRetryMenu({
      target: e.currentTarget,
      dataType: dataType.value,
      mosaicTeamId: teamId,
      targetServiceId,
      isTwoWaySync,
    });
  };

  return <EntityRetryThreeDot onClick={onThreeDotClick} />;
};

export default OptionCell;
